'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        legendAlign: {
            type: String,
            default: undefined,
            kComposite: 'legend.align'
        },
        legendBackground: {
            type: String,
            default: undefined,
            kComposite: 'legend.background'
        },
        legendBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'legend.border.color'
        },
        legendBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'legend.border.dashType'
        },
        legendBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'legend.border.width'
        },
        legendHeight: {
            type: Number,
            default: undefined,
            kComposite: 'legend.height'
        },
        legendInactiveItemsLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'legend.inactiveItems.labels.color'
        },
        legendInactiveItemsLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'legend.inactiveItems.labels.font'
        },
        legendInactiveItemsLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'legend.inactiveItems.labels.template'
        },
        legendItemCursor: {
            type: String,
            default: undefined,
            kComposite: 'legend.item.cursor'
        },
        legendItemVisual: {
            type: Function,
            default: undefined,
            kComposite: 'legend.item.visual'
        },
        legendLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'legend.labels.color'
        },
        legendLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'legend.labels.font'
        },
        legendLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.margin'
        },
        legendLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.margin.bottom'
        },
        legendLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.margin.left'
        },
        legendLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.margin.right'
        },
        legendLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.margin.top'
        },
        legendLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.padding'
        },
        legendLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.padding.bottom'
        },
        legendLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.padding.left'
        },
        legendLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.padding.right'
        },
        legendLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.padding.top'
        },
        legendLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'legend.labels.template'
        },
        legendMargin: {
            type: Number,
            default: undefined,
            kComposite: 'legend.margin'
        },
        legendMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'legend.margin.bottom'
        },
        legendMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'legend.margin.left'
        },
        legendMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'legend.margin.right'
        },
        legendMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'legend.margin.top'
        },
        legendOffsetX: {
            type: Number,
            default: undefined,
            kComposite: 'legend.offsetX'
        },
        legendOffsetY: {
            type: Number,
            default: undefined,
            kComposite: 'legend.offsetY'
        },
        legendOrientation: {
            type: String,
            default: undefined,
            kComposite: 'legend.orientation'
        },
        legendPadding: {
            type: Number,
            default: undefined,
            kComposite: 'legend.padding'
        },
        legendPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'legend.padding.bottom'
        },
        legendPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'legend.padding.left'
        },
        legendPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'legend.padding.right'
        },
        legendPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'legend.padding.top'
        },
        legendPosition: {
            type: String,
            default: undefined,
            kComposite: 'legend.position'
        },
        legendReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'legend.reverse'
        },
        legendVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'legend.visible'
        },
        legendWidth: {
            type: Number,
            default: undefined,
            kComposite: 'legend.width'
        }
    }
};